<template>
  <q-btn-dropdown size="md"
                  flat="flat"
                  :class="componentClass"
                  :ha-force="haForce"
                  :auth-force="authForce"
  >
    <q-list ref="qList"
            link
            class="q-btn-dropdown-select-menu"
    >
      <q-item v-for="option in selectOptions"
              :key="options.value"
              :ha-force="haForce"
              :auth-force="authForce"
              v-close-overlay
              @click.native="onClickSelectedOption"
      >
        <q-item-main class="q-btn-dropdown-select-item"
                     :value="option.value"
        >
          <q-radio v-model="selectedValue"
                   style="margin-right: 5px"
                   :val="option.value"
                   :ha-force="haForce"
                   :auth-force="authForce"
                   @input="onClickSelectedOption"
          />
          <span v-if="option.icon"
                :class="`q-btn-dropdown-select-item-icon ${option.icon}`"
          />
          <span>{{ option.label }}</span>
        </q-item-main>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
  export default {
    name: 'QDropdownSelect',
    components: {},
    directives: {},
    mixins: [],
    data () {
      return {
        selectedValue: '',
        selectOptions: []
      }
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      options: {
        type: Array,
        default: () => []
      },
      haForce: {
        type: Boolean,
        default: true
      },
      authForce: {
        type: Boolean,
        default: true
      },
      iconClass: {
        type: String,
        default: ''
      }
    },
    computed: {
      componentClass () {
        return `bs bs-q-btn-dropdown-md bs-q-btn-dropdown-flat-type ${this.iconClass}`
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      this.selectedValue = this.value
      this.selectOptions = this.options
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      /*
        이름: onClickSelectedOption
        설명: 선택된 옵션을 내부 모델에 설정하고 부모 컴포넌트에 알린다.
      */
      onClickSelectedOption (newValue) {
        if (typeof newValue === 'string') {
          this.selectedValue = newValue
        } else {
          const targetEl = newValue.target

          if (targetEl.tagName.toUpperCase() === 'DIV') {
            this.selectedValue = targetEl.getAttribute('value') || ''
          } else {
            this.selectedValue = targetEl.parentElement.getAttribute('value') || ''
          }
        }

        // 모델 반영을 위한 Input, 컴포넌트 Change 이벤트 사용을 위한 change 이벤트 호출
        this.$emit('input', this.selectedValue)
        this.$emit('change', this.selectedValue)

        // QList 부모는 QPopover 컴포넌트, close overlay 속성이 먹히지 않으므로 강제로 hide 호출
        if (this.$refs.qList.$parent) {
          this.$refs.qList.$parent.hide()
        }
      }
    },
    watch: {
      /*
        이름: value
        설명: v-model에 바인딩된 value 를 감시한다.
      */
      value (newValue) {
        this.selectedValue = newValue
      },
      /*
        이름: options
        설명: Q-Dropdown-Select 컴포넌트의 옵션을 초기화한다.
      */
      options (newOptions) {
        this.selectOptions = newOptions
      }
    }
  }
</script>

<style scoped>
  .q-btn-dropdown-select-menu {
    cursor: pointer;
  }

  .q-btn-dropdown-select-item {
    display: flex;
    align-items: center;
  }

  .q-btn-dropdown-select-item-icon {
    width: 34px;
    display: inline-block;
    margin-right: 5px;
  }
</style>
